import { BehaviorSubject, combineLatest, map } from "rxjs";
import {
  DEFAULT_LOOKUP_RELAYS,
  DEFAULT_RELAYS,
  LOCAL_MESH_RELAY,
} from "../const";
import { LatLngLiteral } from "leaflet";

// save and load settings from localStorage
function persist<T>(key: string, subject: BehaviorSubject<T>) {
  try {
    if (localStorage.getItem(key))
      subject.next(JSON.parse(localStorage.getItem(key)!));
  } catch {}
  subject.subscribe((value) => {
    localStorage.setItem(key, JSON.stringify(value));
  });
}

export const lookupRelays = new BehaviorSubject<string[]>(
  DEFAULT_LOOKUP_RELAYS,
);
persist("lookup-relays", lookupRelays);

export const defaultRelays = new BehaviorSubject<string[]>(DEFAULT_RELAYS);
persist("default-relays", defaultRelays);

export const localMeshRelayEnabled = new BehaviorSubject(false);
persist("local-mesh-relay-enabled", localMeshRelayEnabled);

export function withLocalMeshRelay(relays: readonly string[] = []) {
  const next = [...relays];
  if (localMeshRelayEnabled.getValue() && !next.includes(LOCAL_MESH_RELAY))
    next.push(LOCAL_MESH_RELAY);
  return next;
}

export const effectiveDefaultRelays = combineLatest([
  defaultRelays,
  localMeshRelayEnabled,
]).pipe(map(([relays]) => withLocalMeshRelay(relays)));

export const homeMapCenter = new BehaviorSubject<{
  center: LatLngLiteral;
  zoom: number;
} | null>(null);
persist("home-map-center", homeMapCenter);
